/* ============================================================
   Craftier — lead capture interstitial
   Config lives in snippets/craftier-config.liquid (window.CRAFTIER).
   ============================================================ */

(function () {
  'use strict';

  var CFG  = window.CRAFTIER || {};
  var OPT  = CFG.lead || {};
  var root = document.getElementById('cr-lead');
  if (!root) return;

  /* Never fire inside the theme editor — it makes the section unusable. */
  if (window.Shopify && window.Shopify.designMode) return;

  var params = new URLSearchParams(window.location.search);

  /* ---------- QA switches ----------
     ?crlead=1     force open immediately
     ?crlead=reset clear all caps, then behave normally
     ?nopopup=1    suppress (use on paid-traffic QA links)          */
  var force = params.get('crlead') === '1';
  if (params.get('crlead') === 'reset') clearCaps();
  if (params.get('nopopup') === '1') return;

  /* ---------- frequency capping ---------- */

  var K_DONE   = 'cr_lead_captured';
  var K_SNOOZE = 'cr_lead_snoozed';
  var K_SEEN   = 'cr_lead_seen_session';

  function store(k, days) {
    try {
      localStorage.setItem(k, JSON.stringify({
        at: Date.now(),
        until: Date.now() + days * 864e5
      }));
    } catch (e) {}
  }

  function held(k) {
    try {
      var raw = localStorage.getItem(k);
      if (!raw) return false;
      var v = JSON.parse(raw);
      if (Date.now() > v.until) { localStorage.removeItem(k); return false; }
      return true;
    } catch (e) { return false; }
  }

  function clearCaps() {
    try {
      localStorage.removeItem(K_DONE);
      localStorage.removeItem(K_SNOOZE);
      sessionStorage.removeItem(K_SEEN);
    } catch (e) {}
  }

  function suppressed() {
    if (force) return false;
    if (held(K_DONE) || held(K_SNOOZE)) return true;
    if (OPT.oncePerSession !== false) {
      try { if (sessionStorage.getItem(K_SEEN)) return true; } catch (e) {}
    }
    /* Someone mid-purchase should never be interrupted. */
    var path = window.location.pathname;
    if (/\/(cart|checkouts?|account|challenge)/.test(path)) return true;
    return false;
  }

  if (suppressed()) return;

  /* ---------- elements ---------- */

  var scrim   = root.querySelector('[data-crl-close]');
  var closeEl = root.querySelectorAll('[data-crl-close]');
  var stepPhone = root.querySelector('[data-crl-step="phone"]');
  var stepCode  = root.querySelector('[data-crl-step="code"]');
  var stepDone  = root.querySelector('[data-crl-step="done"]');
  var phoneEl   = root.querySelector('[data-crl-phone]');
  var codeEl    = root.querySelector('[data-crl-code]');
  var consentEl = root.querySelector('[data-crl-consent]');
  var msgEl     = root.querySelector('[data-crl-msg]');
  var sendBtn   = root.querySelector('[data-crl-send]');
  var verifyBtn = root.querySelector('[data-crl-verify]');
  var backBtn   = root.querySelector('[data-crl-back]');
  var waLink    = root.querySelector('[data-crl-wa]');

  var opened = false;
  var lastFocus = null;

  /* ---------- open / close ---------- */

  function open() {
    if (opened) return;
    opened = true;
    teardownTriggers();

    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem(K_SEEN, '1'); } catch (e) {}

    setTimeout(function () { phoneEl && phoneEl.focus(); }, 60);
    emit('craftier_lead_shown', {});
  }

  function close(reason) {
    root.hidden = true;
    document.body.style.overflow = '';
    if (reason === 'dismiss') store(K_SNOOZE, OPT.snoozeDays || 7);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  Array.prototype.forEach.call(closeEl, function (b) {
    b.addEventListener('click', function () { close('dismiss'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close('dismiss');
  });

  /* Keep tab focus inside the panel while it's open. */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || root.hidden) return;
    var f = root.querySelectorAll('button, input, a[href]');
    var list = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- triggers ---------- */

  var landed = Date.now();
  var timers = [];
  var bound  = [];

  function on(target, evt, fn, opts) {
    target.addEventListener(evt, fn, opts);
    bound.push([target, evt, fn]);
  }

  function teardownTriggers() {
    timers.forEach(clearTimeout);
    bound.forEach(function (b) { b[0].removeEventListener(b[1], b[2]); });
    timers = []; bound = [];
  }

  function elapsed() { return (Date.now() - landed) / 1000; }

  function ready() {
    if (elapsed() < (OPT.minDwell || 12)) return false;
    if (document.hidden) return false;
    /* Don't interrupt someone typing or mid-interaction with another dialog. */
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return false;
    if (document.querySelector('.cr-modal:not([hidden]), cart-drawer.active, .menu-drawer.active')) return false;
    return true;
  }

  function tryOpen() { if (ready()) open(); }

  if (force) {
    setTimeout(open, 200);
  } else {
    /* dwell */
    if (OPT.dwell) {
      timers.push(setTimeout(tryOpen, OPT.dwell * 1000));
    }

    /* scroll depth */
    if (OPT.scrollDepth) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        var pct = (window.pageYOffset / h) * 100;
        if (pct >= OPT.scrollDepth) tryOpen();
      };
      on(window, 'scroll', onScroll, { passive: true });
    }

    /* exit intent — desktop pointers only, mobile has no cursor to lose */
    if (OPT.exitIntent && window.matchMedia('(pointer: fine)').matches) {
      on(document, 'mouseout', function (e) {
        if (e.relatedTarget || e.clientY > 0) return;
        tryOpen();
      });
    }
  }

  /* ---------- helpers ---------- */

  function say(text, kind) {
    if (!msgEl) return;
    msgEl.textContent = text || '';
    msgEl.className = 'crl__msg' + (kind ? ' crl__msg--' + kind : '');
  }

  function digits(v) { return String(v || '').replace(/\D/g, ''); }

  function validPhone(p) { return /^[6-9]\d{9}$/.test(p); }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function emit(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail));
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  /* ---------- lead sink ---------- */

  function saveLead(phone) {
    var payload = {
      phone: phone,
      source: 'pdp_popup',
      product: root.dataset.crlProduct || '',
      url: window.location.href,
      ts: new Date().toISOString()
    };

    var jobs = [];

    if (CFG.leadEndpoint) {
      jobs.push(post(CFG.leadEndpoint, payload).catch(function () {}));
    }

    /* Zero-backend fallback: the number rides along on the order. */
    if (CFG.leadToCartAttributes !== false) {
      jobs.push(
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Lead Phone': '+91' + phone } })
        }).catch(function () {})
      );
    }

    store(K_DONE, OPT.captureDays || 90);
    emit('craftier_lead_captured', { phone: phone, source: 'pdp_popup' });
    if (typeof window.fbq === 'function') window.fbq('track', 'Lead');

    return Promise.all(jobs);
  }

  function showDone(phone) {
    stepPhone.hidden = true;
    stepCode.hidden = true;
    stepDone.hidden = false;
    say('');

    if (waLink) {
      var text = 'Hi Craftier, I saved a design and would like to know more. (My number: +91' + phone + ')';
      waLink.href = 'https://wa.me/' + (CFG.whatsapp || '') +
                    '?text=' + encodeURIComponent(text);
    }
  }

  /* ---------- submit flow ---------- */

  sendBtn && sendBtn.addEventListener('click', function () {
    var phone = digits(phoneEl.value);

    if (!validPhone(phone))  return say('Enter a valid 10-digit mobile number.', 'err');
    if (!consentEl.checked)  return say('Please accept the Terms and Privacy Policy to continue.', 'err');

    /* No OTP backend configured — capture and finish. */
    if (!CFG.otpEndpoint) {
      sendBtn.disabled = true;
      say('Saving\u2026');
      saveLead(phone).then(function () { showDone(phone); });
      return;
    }

    sendBtn.disabled = true;
    say('Sending OTP\u2026');

    post(CFG.otpEndpoint, { action: 'send', phone: phone })
      .then(function (res) {
        if (!res || !res.ok) throw new Error();
        stepPhone.hidden = true;
        stepCode.hidden = false;
        say('OTP sent to +91 ' + phone + '.', 'ok');
        codeEl.focus();
      })
      .catch(function () {
        /* Verification is a nice-to-have; the lead is the point.
           Don't lose it because an SMS gateway hiccuped. */
        say('Could not send the OTP \u2014 saving your number anyway.', 'err');
        saveLead(phone).then(function () {
          setTimeout(function () { showDone(phone); }, 900);
        });
      })
      .then(function () { sendBtn.disabled = false; });
  });

  verifyBtn && verifyBtn.addEventListener('click', function () {
    var phone = digits(phoneEl.value);
    var code  = digits(codeEl.value);

    if (code.length < 4) return say('Enter the OTP you received.', 'err');

    verifyBtn.disabled = true;
    say('Verifying\u2026');

    post(CFG.otpEndpoint, { action: 'verify', phone: phone, code: code })
      .then(function (res) {
        if (!res || !res.ok) throw new Error();
        return saveLead(phone).then(function () { showDone(phone); });
      })
      .catch(function () { say('That OTP did not match. Try again.', 'err'); })
      .then(function () { verifyBtn.disabled = false; });
  });

  backBtn && backBtn.addEventListener('click', function () {
    stepCode.hidden = true;
    stepPhone.hidden = false;
    say('');
    phoneEl.focus();
  });

  /* Enter submits the visible step. */
  [phoneEl, codeEl].forEach(function (input) {
    if (!input) return;
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      (input === phoneEl ? sendBtn : verifyBtn).click();
    });
  });
})();
